/**
 * 注意：执行compile命令会重新生成本文件，所以请不要修改本文件
 */
import idMap from "./idMap.js"                                             // 语言ID映射文件
import { translate,VoerkaI18nScope  } from "@voerkai18n/runtime"
import defaultFormatters from "./formatters/zh.js"             // 默认语言格式化器
import defaultMessages from "./zh.js"
import storage  from "./storage.js"
import i18n from './specialI18n'



const messages = {
    'zh' :  defaultMessages,
    'en' : ()=>import("./en.js")
}

const formatters = {
    'zh' :  defaultFormatters,
    'en' : ()=>import("./formatters/en.js")
}

// 语言配置文件
const scopeSettings = {
    "languages": [
        {
            "name": "zh",
            "title": "中文",
            "default": true,
            "active": true
        },
        {
            "name": "en",
            "title": "英语"
        }
    ],
    "namespaces": {
        "basicData": [
            "/basicdata"
        ],
        "commodityCenter": [
            "/commoditycenter"
        ],
        "financeCenter": [
            "/financecenter"
        ],
        "inventoryCenter": [
            "/inventorycenter"
        ],
        "monitorPlatform": [
            "/monitorplatform"
        ],
        "orderCenter": [
            "/ordercenter"
        ],
        "promotionCenter": [
            "/promotioncenter"
        ],
        "reportCenter": [
            "/reportcenter"
        ],
        "strategyPlatform": [
            "/strategyplatform"
        ],
        "systemConfig": [
            "/systemconfig"
        ]
    }
}

// 语言作用域
const scope = new VoerkaI18nScope({
    id          : "burgeon-r3-project",                    // 当前作用域的id，自动取当前工程的package.json的name
    debug       : false,                            // 是否在控制台输出调试信息
    idMap,                                          // 消息id映射列表
    library     : false,                      // 开发库时设为true
    messages,                                       // 语言包+
    formatters,                                     // 扩展自定义格式化器
    storage,                                        // 语言配置存储器
    ...scopeSettings
})
// 翻译函数
const scopedTtranslate = translate.bind(scope)
window.t = scopedTtranslate

export {
    i18n,
    scopedTtranslate as t,
    scope as i18nScope
}
